export default class Swipe {
  constructor(element) {
    this.xDown = null;
    this.yDown = null;
    this.element =
      typeof element === 'string' ? document.querySelector(element) : element;

    this.onTouchMoveBinded = this.onTouchMove.bind(this);
    this.onTouchStartBinded = this.onTouchStart.bind(this);

    this.element.addEventListener('touchstart', this.onTouchStart, false);
    this.element.addEventListener('touchmove', this.onTouchMove, false);
  }

  deconstructor = () => {
    this.element.removeEventListener(
      'touchstart',
      this.onTouchStartBinded,
      false
    );
    this.element.removeEventListener(
      'touchmove',
      this.onTouchMoveBinded,
      false
    );
  };

  onTouchStart = (event) => {
    this.xDown = event.touches[0].clientX;
    this.yDown = event.touches[0].clientY;
  };

  onLeft(callback) {
    this.onLeft = callback;

    return this;
  }

  onRight(callback) {
    this.onRight = callback;

    return this;
  }

  onUp(callback) {
    this.onUp = callback;

    return this;
  }

  onDown(callback) {
    this.onDown = callback;

    return this;
  }

  onTouchMove = (evt) => {
    if (!this.xDown || !this.yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;

    // Most significant.
    if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
      if (this.xDiff > 0) {
        this.onLeft?.();
      } else {
        this.onRight?.();
      }
    } else if (this.yDiff > 0) {
      this.onUp?.();
    } else {
      this.onDown?.();
    }

    // Reset values.
    this.xDown = null;
    this.yDown = null;
  };
}
